const icon = require('vue-svgicon');
icon.register({
    'edit': {
        width: 18,
        height: 18,
        viewBox: '0 0 18 18',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M11.037 7.376l-4.922 8.54-4.034 1.083L1 12.958l4.922-8.542.492-.854L7.89 1l5.115 2.959-1.637 2.84-.331.577zm-3.035 9.622v-1H17v1H8.002zm-5.183-1.28l-.72-2.694 3.41 1.972-2.69.722zm-.228-3.548L6 14.142l4.183-7.26-3.41-1.972-4.183 7.26zm4.675-8.115l.985-1.708 3.41 1.972-.985 1.709-3.41-1.973z" _fill="#27242D"/>`,
    },
});
